<template>
  <div class="table" :style="{'width': getScaleByUI(width + 'px')}">
    <div class="table-head" :style="{
        'height': getScaleByUI(lineHeight + 'px'),
        'background': headColor
      }">
      <div class="table-head__body"
        v-for="item in head"
        :style="{'width': getScaleByUI(calTableWidth(item.width) + 'px')}"
        :key="item.prop"
        v-html="item.name"></div>
    </div>
    <div class="table-content" :style="{'height': getScaleByUI(height + 'px')}">
      <template v-if="tableShowData.length != 0">
        <div class="table-content-line"
          v-for="(item, index) in tableShowData"
          :key="index"
          :style="{'height': getScaleByUI(lineHeight + 'px')}">
          <div class="table-content-line__body"
            :class="{'table-content-line__img' : head[i].prop == 'img'}"
            v-for="(line, i) in item"
            :key="i + index"
            :style="{'width': getScaleByUI(head[i].width + 'px')}">
            <template v-if="head[i].prop == 'radio'">
              <el-radio :value="radioIndex" :label="index" @input="changeRadioIndex">{{ '' }}</el-radio>
            </template>
            <template v-else-if="head[i].prop == 'check'">
              <el-checkbox :value="item.check" @change="changeCheck(index)"></el-checkbox>
            </template>
            <template v-else-if="head[i].prop == 'img'">
              <img
                :src="'/api/support-server/v1/fileInfo/downloadFile/' + line"
                :style="{'height': getScaleByUI(lineHeight * 0.5 + 'px')}"
                alt="" >
            </template>
            <template v-else-if="head[i].prop == 'operate'">
              <template v-if="!body[index]['^operate-_^']">
                <div class="table-content-line__btn" @click="changeBtnClick(index)">修改</div>
                <div class="table-content-line__btn" @click="deleteBtnClick(index)">删除</div>
              </template>
              <template v-else>
                ------
              </template>
            </template>
            <template v-else-if="head[i].prop.includes('^input-_^')">
              <el-input
                size="mini"
                :value="line"
                :disabled="body[index][head[i].prop]"
                type="number"
                @input="changeInput($event, index, head[i].prop)"></el-input>
            </template>
            <template v-else-if="head[i].prop.includes('^file-_^')">
            <template v-if="!line">
                <div class="table-content-line__btn">上传</div>
              </template>
              <template v-else>
                <div class="table-content-line__btn">查看</div>
                <div class="table-content-line__btn" v-if="!head[i].disable">删除</div>
              </template>
            </template>
            <template v-else>
              <div class="table-content-line__html" v-html="line"></div>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="table-content__img">
          <img :src="imgArray[noDataImgIndex]" alt="">
          <div class="table-content__img__text" v-html="noDataPromptText"></div>
        </div>
      </template>
    </div>
    <div class="table-bottom">
      <div class="table-bottom-summary" v-if="tableShowData.length != 0">
        <div class="table-bottom-summary__body"
          v-for="item in summaryData"
          :key="item.name">
          {{ item.name }}: {{ item.preUnit }}{{ item.data }}{{ item.unit }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalData from 'common/globalData';
export default {
  name: 'Table',
  props: {
    /**表头 */
    head: {
      type: Array,
    },
    /**表头颜色 */
    headColor: {
      type: String,
      default: '#e6f7ff'
    },
    /**表格数据 */
    body: {
      type: Array,
    },
    /**表格列表高度 */
    lineHeight: {
      type: String,
      default: '50'
    },
    /**选择索引 */
    radioIndex: {
      type: Number,
      default: null
    },
    /**汇总数据 */
    summaryData:{
      type: Array
    },
    /**最小高度 */
    height: {
      type: String,
      default: '300'
    },
    /**宽度 */
    width: {
      type: String,
      default: '1200'
    },
    /**无数据文字提示 */
    noDataPromptText: {
      type: String,
      default: '暂无数据'
    },
    /**无数据图片提示索引 */
    noDataImgIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      imgArray: [
        require('../../assets/img/无数据.svg'),
        require('../../assets/img/shark.png')
      ]
    }
  },
  computed:{
    tableShowData(){
      if(!this.body) return []
      return this.body.map(e => this.head.map(h => {
        if(h.prop.includes('-_^')){
          return e[h.prop.split('-_^')[1]]
        }
        return e[h.prop]
      }))
    }
  },
  methods:{
    getScaleByUI: globalData.getScaleByUI,
    /**计算对应表格宽度 */
    calTableWidth(width){
      let totalWidth = [...this.head.map(item => item.width)].reduce((acc, curr) => Number(acc) + Number(curr), 0)
      let tableWidth = this.width
      let resWidth = tableWidth * width / totalWidth
      return resWidth
    },
    changeRadioIndex(e){
      this.$emit('changeRadioIndex', e)
    },
    changeCheck(e){
      this.$emit('clickCheck', e)
    },
    changeBtnClick(index){
      this.$emit('changeData', index)
    },
    deleteBtnClick(index){
      this.$confirm('数据删除后不可恢复，请确认是否要删除数据').then(() => {
        this.$emit('deleteData', index)
      }).catch(() => {})
    },
    changeInput(value, index, key){
      this.$emit('changeInput', value, index, key.split('-_^')[1])
    }
  }
}
</script>

<style lang="scss" scoped>
.table{
  &-head{
    display: flex;
    align-items: center;
    font-size: 12px;
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    &__body{
      color: black;
      text-align: center;
    }
  }
  &-content{
    position: relative;
    &-line{
      display: flex;
      background-color: #FFFFFF;
      align-items: center;
      font-size: 12px;
      border-bottom: 1px solid #e6e6e6;
      &__body{
        color: black;
        text-align: center;
      }
      &__html{
        overflow: hidden;
      }
      &__img{
        overflow: hidden;
      }
      &__btn{
        font-size: 12px;
        color: #00a0c7;
        margin: 5px auto;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
    &__img{
      // width: 200px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      img{
        width: 200px;
      }
      &__text{
        color: #999999;
      }
    }
  }
  &-bottom{
    display: flex;
    justify-content: space-between;
    &-summary{
      display: flex;
      color: #00a0c7;
      font-weight: bold;
      padding: 10px 5px;
      &__body{
        margin: 0 5px;
      }
    }
  }
}
</style>
